import './SplitContent.scss'
import React from 'react'

const SplitContent = ({ children }) => {
  const getComponent = (key) => {
    return children.filter((comp) => {
      return comp.key === key
    })
  }

  return (
    <div className="page-content split">
      <div className="page-section left">{getComponent('split-left')}</div>
      <div className="page-section right">
        <div className="page-content-scroll">{getComponent('split-right')}</div>
      </div>
    </div>
  )
}

export default SplitContent
